import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

const CORES_PRIORIDADE = {
  urgente: '#C62828',
  alta:    '#E07A0B',
  normal:  '#4A8C64',
  baixa:   '#7a7a7a',
};

function formatarData(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function Avisos() {
  const { temPermissao } = useAuth();
  const [avisos, setAvisos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    try {
      const { data } = await api.get('/avisos');
      setAvisos(data.avisos);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao carregar avisos');
    } finally {
      setCarregando(false);
    }
  }

  async function marcarVisualizado(aviso) {
    if (aviso.visualizado) return;
    try {
      await api.post(`/avisos/${aviso.id}/visualizar`);
      setAvisos(avs => avs.map(a => a.id === aviso.id ? { ...a, visualizado: 1 } : a));
    } catch (_) {}
  }

  return (
    <>
      <Header />
      <main className="conteudo-container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <h1 style={{ color: 'var(--verde)', fontWeight: 700, marginBottom: 4 }}>Mural de Avisos</h1>
            <p style={{ color: 'var(--texto-suave)', margin: 0 }}>Comunicados importantes do Centrão.</p>
          </div>
          {temPermissao('publicar_aviso') && (
            <div style={{ display: 'flex', gap: 8 }}>
              <Link to="/admin/avisos" className="btn btn-outline-secondary">
                <i className="bi bi-sliders me-1"></i> Gerenciar
              </Link>
              <Link to="/admin/avisos/novo" className="btn-centrao">
                <i className="bi bi-plus-lg me-1"></i> Novo aviso
              </Link>
            </div>
          )}
        </div>

        {carregando && <div>Carregando…</div>}
        {erro && <div className="erro">{erro}</div>}

        {!carregando && avisos.length === 0 && (
          <div className="conteudo-card" style={{ textAlign: 'center', padding: '40px 16px' }}>
            <i className="bi bi-megaphone" style={{ fontSize: '2.5rem', color: 'var(--texto-suave)' }}></i>
            <p style={{ color: 'var(--texto-suave)', marginTop: 12 }}>Nenhum aviso por enquanto.</p>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {avisos.map(a => (
            <div
              key={a.id}
              className="conteudo-card"
              onClick={() => marcarVisualizado(a)}
              style={{
                cursor: 'pointer',
                borderLeft: `4px solid ${CORES_PRIORIDADE[a.prioridade] || '#4A8C64'}`,
                opacity: a.visualizado ? 0.78 : 1,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}>{a.titulo}</h3>
                  <div style={{ fontSize: '0.75rem', color: 'var(--texto-suave)', marginTop: 4 }}>
                    {formatarData(a.data_inicio || a.created_at)}
                    {a.prioridade !== 'normal' && (
                      <span style={{
                        marginLeft: 8,
                        padding: '2px 8px',
                        borderRadius: 10,
                        background: CORES_PRIORIDADE[a.prioridade],
                        color: '#fff',
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                      }}>
                        {a.prioridade}
                      </span>
                    )}
                  </div>
                </div>
                {!a.visualizado && (
                  <span title="Novo" style={{
                    width: 10, height: 10, borderRadius: '50%',
                    background: 'var(--verde)', flexShrink: 0, marginTop: 8,
                  }} />
                )}
              </div>
              {a.conteudo && (
                <div style={{ marginTop: 10, fontSize: '0.92rem', whiteSpace: 'pre-wrap' }}>
                  {a.conteudo}
                </div>
              )}
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
